import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import { EventCard } from 'sections/Events/components/EventCard';
import { cardsData } from 'sections/Events/data';
import { Card } from 'sections/Events/components/EventCard/EventCard.types';
import styles from 'styles/pages/Events/Events.module.scss'

const cn = classNames.bind(styles);

export default function EventsMainPage() {
  const cards = cardsData.map((card: Card) => {
    return <EventCard key={card.id} cardsData={card}/>
  });
  
  return (
    <div className={cn('events')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Events', href: '' }]} />

        <div className={cn('events__content')}>
          <h1 className={cn('events__heading-h1')}>Upcoming Events</h1>
          <div className={cn('events__cards')}>
            {cards}
          </div>
        </div>

      </div>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: "Explore Upcoming Events at DF Alliance | DF Alliance",
      description:
        'Stay updated on DF Alliance\'s latest events and industry gatherings, offering networking opportunities and insights into the future of freight forwarding.',
      keywords:
        'digital freight alliance, freight alliance, freight online, online freight marketplace, ocean freight online, logistics member portal',
      path: '/events',
    },
  };
};

EventsMainPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
